import { IBeginnersGuideContext } from './context/beginnersGuideContext.t';
import { useSelector } from 'react-redux';
import { getIsLocationPlatformMobileSelector } from '../../Location/locationSelectors';
import BeginnersGuideMobileLoadable from './BeginnersGuideMobileLoadable';
import BeginnersGuideDesktopLoadable from './desktop/BeginnersGuideDesktopLoadable';

export interface IBeginnersGuideProps {
    activeStepIndex: number,
    beginnersGuideContextValue: IBeginnersGuideContext,
}

function BeginnersGuide(props: IBeginnersGuideProps) {
    const isMobilePlatform = useSelector(getIsLocationPlatformMobileSelector);

    return <>
        {
            isMobilePlatform
                ? <BeginnersGuideMobileLoadable {...props}/>
                : <BeginnersGuideDesktopLoadable {...props}/>
        }
    </>
}

export default BeginnersGuide;
